import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\V1\MiniAppTopUpController::availability
* @see app/Http/Controllers/Api/V1/MiniAppTopUpController.php:23
* @route '/api/v1/mini-app/online-topup'
*/
export const availability = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: availability.url(options),
    method: 'get',
})

availability.definition = {
    methods: ["get","head"],
    url: '/api/v1/mini-app/online-topup',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\V1\MiniAppTopUpController::availability
* @see app/Http/Controllers/Api/V1/MiniAppTopUpController.php:23
* @route '/api/v1/mini-app/online-topup'
*/
availability.url = (options?: RouteQueryOptions) => {
    return availability.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\V1\MiniAppTopUpController::availability
* @see app/Http/Controllers/Api/V1/MiniAppTopUpController.php:23
* @route '/api/v1/mini-app/online-topup'
*/
availability.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: availability.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppTopUpController::availability
* @see app/Http/Controllers/Api/V1/MiniAppTopUpController.php:23
* @route '/api/v1/mini-app/online-topup'
*/
availability.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: availability.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppTopUpController::availability
* @see app/Http/Controllers/Api/V1/MiniAppTopUpController.php:23
* @route '/api/v1/mini-app/online-topup'
*/
const availabilityForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: availability.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppTopUpController::availability
* @see app/Http/Controllers/Api/V1/MiniAppTopUpController.php:23
* @route '/api/v1/mini-app/online-topup'
*/
availabilityForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: availability.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppTopUpController::availability
* @see app/Http/Controllers/Api/V1/MiniAppTopUpController.php:23
* @route '/api/v1/mini-app/online-topup'
*/
availabilityForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: availability.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

availability.form = availabilityForm

/**
* @see \App\Http\Controllers\Api\V1\MiniAppTopUpController::start
* @see app/Http/Controllers/Api/V1/MiniAppTopUpController.php:31
* @route '/api/v1/mini-app/online-topup'
*/
export const start = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: start.url(options),
    method: 'post',
})

start.definition = {
    methods: ["post"],
    url: '/api/v1/mini-app/online-topup',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\V1\MiniAppTopUpController::start
* @see app/Http/Controllers/Api/V1/MiniAppTopUpController.php:31
* @route '/api/v1/mini-app/online-topup'
*/
start.url = (options?: RouteQueryOptions) => {
    return start.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\V1\MiniAppTopUpController::start
* @see app/Http/Controllers/Api/V1/MiniAppTopUpController.php:31
* @route '/api/v1/mini-app/online-topup'
*/
start.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: start.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppTopUpController::start
* @see app/Http/Controllers/Api/V1/MiniAppTopUpController.php:31
* @route '/api/v1/mini-app/online-topup'
*/
const startForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: start.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppTopUpController::start
* @see app/Http/Controllers/Api/V1/MiniAppTopUpController.php:31
* @route '/api/v1/mini-app/online-topup'
*/
startForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: start.url(options),
    method: 'post',
})

start.form = startForm

/**
* @see \App\Http\Controllers\Api\V1\MiniAppTopUpController::show
* @see app/Http/Controllers/Api/V1/MiniAppTopUpController.php:51
* @route '/api/v1/mini-app/online-topup/{payment}'
*/
export const show = (args: { payment: string | number } | [payment: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/api/v1/mini-app/online-topup/{payment}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\V1\MiniAppTopUpController::show
* @see app/Http/Controllers/Api/V1/MiniAppTopUpController.php:51
* @route '/api/v1/mini-app/online-topup/{payment}'
*/
show.url = (args: { payment: string | number } | [payment: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { payment: args }
    }

    if (Array.isArray(args)) {
        args = {
            payment: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        payment: args.payment,
    }

    return show.definition.url
            .replace('{payment}', parsedArgs.payment.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\V1\MiniAppTopUpController::show
* @see app/Http/Controllers/Api/V1/MiniAppTopUpController.php:51
* @route '/api/v1/mini-app/online-topup/{payment}'
*/
show.get = (args: { payment: string | number } | [payment: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppTopUpController::show
* @see app/Http/Controllers/Api/V1/MiniAppTopUpController.php:51
* @route '/api/v1/mini-app/online-topup/{payment}'
*/
show.head = (args: { payment: string | number } | [payment: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppTopUpController::show
* @see app/Http/Controllers/Api/V1/MiniAppTopUpController.php:51
* @route '/api/v1/mini-app/online-topup/{payment}'
*/
const showForm = (args: { payment: string | number } | [payment: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppTopUpController::show
* @see app/Http/Controllers/Api/V1/MiniAppTopUpController.php:51
* @route '/api/v1/mini-app/online-topup/{payment}'
*/
showForm.get = (args: { payment: string | number } | [payment: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppTopUpController::show
* @see app/Http/Controllers/Api/V1/MiniAppTopUpController.php:51
* @route '/api/v1/mini-app/online-topup/{payment}'
*/
showForm.head = (args: { payment: string | number } | [payment: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

const onlineTopup = {
    availability: Object.assign(availability, availability),
    start: Object.assign(start, start),
    show: Object.assign(show, show),
}

export default onlineTopup